<template>
  <div class="user-card-container">
    <img :src="imageUrl ? imageUrl : getImageUrl()" :alt="name">

    <div class="user-card-container__role-tag">
      <span>{{ roleLabel }}</span>
    </div>

    <div class="user-card-container__inner">
      <p class="user-card-container__meta">{{ category }}{{ category ? ' • ' : '' }}{{ city }}</p>
      <b>{{ name }}</b>
      <span class="user-card-container__email" v-if="email">{{ email }}</span>

      <div class="user-card-container__bottom">
        <button class="user-card-container__cta" type="button" @click="() => $router.push(`/browse/user/${id}`)">
          Wizytówka
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name:'UserCard',
  props:['imageUrl', 'name', 'category', 'city', 'id', 'role', 'email'],
  computed: {
    roleLabel() {
      if (Number(this.role) === 2) return 'Specjalista'
      if (Number(this.role) === 4) return 'Pracownik'
      if (Number(this.role) === 5) return 'Placówka'
      return 'Użytkownik'
    }
  },
  methods:{
    getImageUrl() {
      return new URL(`../../assets/specialist-placeholder.png`, import.meta.url).href;
    },
  }
}
</script>

<style scoped lang='scss'>
.user-card-container{
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #f3f4f6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  transition: box-shadow .2s ease, transform .2s ease;

  &:hover{
    transform: translateY(-2px);
    box-shadow: 0 16px 28px rgba(0, 0, 0, .12);
  }

  img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  &__role-tag{
    background-color: #ecfdf5;
    color: #047857;
    text-align: center;
    font-size: 1.2rem;
    font-weight: 700;
    padding: 7px 0;
    border-bottom: 1px solid #d1fae5;
  }

  &__inner{
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px;
    min-height: 150px;

    b{
      text-align: left;
      font-size: 1.9rem;
      line-height: 1.3;
      color: #1f2937;
      margin: 0;
      word-break: break-word;
    }
  }

  &__meta{
    margin: 0;
    font-size: 1.3rem;
    color: #6b7280;
    word-break: break-word;
  }

  &__email{
    font-size: 1.3rem;
    color: #6b7280;
    word-break: break-all;
  }

  &__bottom{
    margin-top: auto;
    padding-top: 12px;
    border-top: 1px solid #e5e7eb;
    display: flex;
    justify-content: flex-end;
  }

  &__cta{
    border: none;
    background: #f3f4f6;
    color: #374151;
    padding: 8px 14px;
    border-radius: 8px;
    font-size: 1.3rem;
    font-weight: 600;
    cursor: pointer;
    transition: .2s;

    &:hover{
      background: #10b981;
      color: #fff;
    }
  }
}
</style>